import { Amplify } from 'aws-amplify';
import App from './App';
import awsconfig from './aws-exports';
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@aws-amplify/ui-react/styles.css';
import './styles/index.css';

Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
